import { ActionStore } from "higher-order/ActionStore";

class ContactStore extends ActionStore {
    constructor(props, dispatcher) {
        super(dispatcher);
        this.contactMediaEmail = props.contactMediaEmail;
        this.generalSalesEmail = props.generalSalesEmail;
    }
}

export default ContactStore;